import { Grid, Link, Modal } from "@mui/material";
import * as React from "react";

interface Props {
  open: boolean;
  setUnsavedModalOpen: any;
  onContinue: any;
  onCancel: any;
}

const OverWriteTemplateModal: React.FC<Props> = (props) => {

  const confirmOnSaveModal = () => {
    props.onContinue();
  };

  return (
    <Modal open={props.open} className="unsaved-changes-modal-container">
      <div className="paper">
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <p className="main-header">Overwrite your Template?</p>
            </Grid>
            <Grid item xs={12}>
              <p className="content">
                You have unsaved changes. Switching templates 
                will override your work. Do you want to proceed?
              </p>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={6} className="cancel-link-container">
              <Link
                className="cancel-link"
                onClick={() => props.onCancel()}
              >
                Cancel
              </Link>
            </Grid>
            <Grid item xs={6} className="confirm-btn-container">
              <Link onClick={confirmOnSaveModal} className="confirm-btn">
                Continue
              </Link>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default OverWriteTemplateModal;
